module.exports = "../../app/cells/components/new_faq_cell.rb";